import { render, staticRenderFns } from "./narrative-statement-modal.vue?vue&type=template&id=3588989b"
import script from "./narrative-statement-modal.vue?vue&type=script&lang=js"
export * from "./narrative-statement-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports